import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});

export class OrderNumberFetchAPI {
    static async getOrderNumber(branchoffice_id, token) {

        const res = await server(`/last_order/${branchoffice_id}`,{
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async registerOrder(data, token) {
        const res = await server(`/order`,{
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }


}